@if(inline) {
  <div class="flex items-center justify-center gap-3 py-6">
    <div class="w-8 h-8 border-3 animate-spin border-vivid-royal-200 border-t-vivid-royal-500 rounded-full"></div>
    <span *ngIf="message" class="text-sm text-vivid-royal-500 dark:text-vivid-royal-200 font-medium">{{ message }}</span>
  </div>
} @else {
  <div class="flex mx-auto h-screen w-full items-center">
    <div class="flex-col gap-4 w-full flex items-center justify-center">
      <div class="w-20 h-20 border-6 animate-spin border-vivid-royal-200 border-t-vivid-royal-500 rounded-full"></div>
      <span *ngIf="message" class="text-vivid-royal-500 dark:text-white font-semibold text-lg drop-shadow-sm">{{ message }}</span>
    </div>
  </div>
}
